import { useState } from "react";
import { Workflow } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SlideOver } from "@/components/ui/slide-over";
import { ChainLinkEditor } from "./ChainLinkEditor";

// Spec 083 — ponto de entrada da cadeia no editor da linha, no molde do expediente: um botão que
// abre um painel lateral.
//
// ⚠️ O BOTÃO NÃO CONSULTA. Exibir a contagem no rótulo custaria uma requisição em toda visita ao
// editor da linha, para uma informação que a maioria não abre — e prenderia o botão a um provedor
// de consulta que a tela nem sempre tem. O corpo do painel é quem lê, e só quando ele abre.
export function LineChainEditor({ lineId }: { lineId: string }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button type="button" variant="outline" size="sm" onClick={() => setOpen(true)}>
        <Workflow className="mr-1.5 h-4 w-4" aria-hidden="true" />
        Alimentada por
      </Button>

      <SlideOver open={open} onOpenChange={setOpen} title="Cadeia de produção" width={480}>
        <div className="p-4">{open ? <ChainLinkEditor lineId={lineId} /> : null}</div>
      </SlideOver>
    </>
  );
}

export { ChainLinkEditor };
